import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageBox from '../MessageBox';
import { Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

class ConfirmationButton extends Component {
	constructor(props) {
		super(props);
		this.showConfirmation = this.showConfirmation.bind(this);
		this.hideConfirmation = this.hideConfirmation.bind(this);
		this.state = { showConfirmation: false };
	}

	showConfirmation() {
		this.setState({ showConfirmation: true });
	}

	hideConfirmation() {
		this.setState({ showConfirmation: false });
	}

	render() {
		const { t, onConfirmation, confirmationTitle, confirmationMessage, displayType, label, icon, bsStyle, style, disabled, btnClasses, showLink, iconStyle, ...rest } = this.props;
		let btnIcon = icon;
		let btnStyle = bsStyle;
		if (!btnIcon)
			btnIcon = faXmark;
		if (!btnStyle)
			btnStyle = 'danger';

		return (
			<div style={{ ...style, display: displayType }} {...rest}>
				{!showLink && <Button onClick={this.showConfirmation} className={btnClasses} bsStyle={btnStyle} disabled={disabled}><FontAwesomeIcon icon={btnIcon} style={iconStyle}/> {label}</Button>}
				{showLink && <a onClick={this.showConfirmation} className={btnClasses} bsStyle={btnStyle} style={{ cursor: 'pointer' }} disabled={disabled}><FontAwesomeIcon icon={btnIcon} style={iconStyle} /> {label}</a>}
				<MessageBox
					show={this.state.showConfirmation}
					title={confirmationTitle}
					message={confirmationMessage}
					onConfirm={() => {
						this.hideConfirmation();
						onConfirmation();
					}}
					onCancel={this.hideConfirmation}
				/>
			</div>
		);
	}
}

ConfirmationButton.propTypes = {
	onConfirmation: PropTypes.func,
	confirmationTitle: PropTypes.string,
	confirmationMessage: PropTypes.node
};

export default withTranslation()(ConfirmationButton);